var _polygon, _path, _polygon2, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle2, _path15, _path16, _circle3, _path17, _circle4, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 819,
    height: 697,
    viewBox: "0 0 819 697",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "632.145 673.537 620.504 677.384 600.124 634.316 617.305 628.638 632.145 673.537",
    fill: "#ffb8b8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M803.70539,776.55634h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H788.81854a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,803.70539,776.55634Z",
    transform: "translate(-395.71765 191.70938) rotate(-18.2902)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "555.351 684.229 543.091 684.228 537.259 636.94 555.353 636.941 555.351 684.229",
    fill: "#ffb8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M534.33389,680.72546h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H519.447a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,534.33389,680.72546Z",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M734.51909,610.1897l-.62472,2.76662c-8.44725,37.40925-11.45573,91.84115-8.93257,130.10917l1.94909,29.56113a4,4,0,0,0,3.99133,3.73684h14.698a4,4,0,0,0,3.97261-3.53264l11.40761-96.96472a4,4,0,0,1,7.78693-.73716l29.56536,87.62362a4,4,0,0,0,3.5568,2.78718l22.45121,1.44846a4,4,0,0,0,4.07477-5.187l-13.51432-37.15864c-10.44217-33.34756-16.05519-84.0186-16.66815-118.95745v0a4,4,0,0,0-4.37862-3.91182l-55.81285,5.31551A4,4,0,0,0,734.51909,610.1897Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 576.70058,
    cy: 328.79653,
    r: 24.56103,
    fill: "#a0616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M751.07793,618.23651h0a144.91069,144.91069,0,0,1-14.645-.77247,6.02078,6.02078,0,0,1-5.34766-6.49511l8.374-80.90625c2.01929-22.88477,5.13916-44.97559,20.92457-63.68457a6.01764,6.01764,0,0,1,4.33154-2.127l.59326-.02246c6.22681-.25976,9.09619-.0332,9.90356.77539l4.34278,4.2793c26.48388,19.58594,27.5841,143.66193,21.05919,141.21662-1.2622-.4707-16.33458.00213-17.38366.71795C774.7227,617.01678,761.05009,618.23553,751.07793,618.23651Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#17BED0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M654.71246,573.328a10.05574,10.05574,0,0,1,14.90963-3.93173L698.68582,548.605l.70506,18.55631-27.70751,16.8989A10.11027,10.11027,0,0,1,654.71246,573.328Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#a0616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M683.57709,578.81387l-9.844-17.32882L763.4,496.83067a18.14229,18.14229,0,1,1,18.95437,30.82559Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#17BED0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M778.2357,451.06222a4.8526,4.8526,0,0,0,6.3459.4066c5.78855-4.29092,10.87038-9.632,13.87779-16.14676,3.44606-7.465,3.83051-16.62536-.32438-23.72027-3.51234-5.9977-9.71445-9.868-15.89583-13.046a28.2712,28.2712,0,0,0-7.67384-2.95768,10.93664,10.93664,0,0,0-7.95156,1.283,6.8677,6.8677,0,0,0-3.10059,7.09084,25.847,25.847,0,0,0-11.03188-7.40551,14.267,14.267,0,0,0-8.42531-.61078c-3.92257,1.1126-6.78626,4.59777-8.35256,8.36222a16.72443,16.72443,0,0,0-1.26243,9.1248,11.14647,11.14647,0,0,0,4.87061,7.63469c3.24312,2.00656,7.38055,1.86189,11.10507,1.0421s7.32987-2.24558,11.12646-2.60615,8.02437.58609,10.33493,3.62013c1.62716,2.13665,2.045,4.92842,2.41021,7.58914l1.89978,13.83909a16.88058,16.88058,0,0,0,1.5099,5.78251A3.33361,3.33361,0,0,0,778.2357,451.06222Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M831.22861,623.15271a10.0558,10.0558,0,0,1-1.10132-15.38l-15.04665-32.41262,18.36568,2.74513,11.4729,30.35871a10.11028,10.11028,0,0,1-13.69061,14.68873Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#a0616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M841.29027,588.72168l-17.32882,9.844-64.65438-89.667a18.14229,18.14229,0,1,1,30.82559-18.95437Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#17BED0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "af36087b-ebb7-4586-9a2a-879d85f262d7-112",
    "data-name": "Path 22",
    d: "M683.45388,266.783h-3.82147V162.0937A60.59372,60.59372,0,0,0,619.03872,101.5H397.23287a60.5937,60.5937,0,0,0-60.5937,60.5937V736.43714a60.59371,60.59371,0,0,0,60.5937,60.59369H619.03869a60.5937,60.5937,0,0,0,60.59275-60.59369V341.30285h3.82147Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "bd8e308f-d5b9-490f-b905-e174e794b745-113",
    "data-name": "Path 23",
    d: "M621.48363,117.2585H592.533a21.49818,21.49818,0,0,1-19.90685,29.61744h-127.07a21.49819,21.49819,0,0,1-19.905-29.61744H398.60943a45.25079,45.25079,0,0,0-45.25079,45.25078V736.01875a45.25081,45.25081,0,0,0,45.25079,45.25077h222.8742a45.2508,45.2508,0,0,0,45.25078-45.25077h0V162.50836A45.25078,45.25078,0,0,0,621.4836,117.2585Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M510.04652,456.5a105,105,0,1,1,105-105A105.11906,105.11906,0,0,1,510.04652,456.5Zm0-208a103,103,0,1,0,103,103A103.11661,103.11661,0,0,0,510.04652,248.5Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M548.61109,320.99789c8.99256-7.59865,14.45479-19.60228,13.02232-31.28789s-10.30472-22.42829-21.81332-24.90978-24.62761,4.38768-28.12315,15.62987c-1.92376-21.6745-4.14055-44.25714-15.6641-62.715-10.43429-16.71314-28.50667-28.672-48.09305-30.81147s-40.20832,5.941-52.42363,21.40027-15.20618,37.93388-6.65089,55.68241c6.30238,13.07474,17.91358,22.80511,30.07923,30.72128,38.81262,25.2553,86.95964,33.78829,132.77224,27.04621Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M414.88479,193.29252a317.62453,317.62453,0,0,1,44.26412,43.95415,318.55132,318.55132,0,0,1,49.85571,83.314c.89773,2.19991-2.67454,3.15752-3.56229.98208a316.75849,316.75849,0,0,0-93.16977-125.638c-1.84429-1.5018.78315-4.10164,2.61223-2.61223Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.88414,
    cy: 447,
    r: 11,
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M602.70891,556.5h-140a8,8,0,1,1,0-16h140a8,8,0,0,1,0,16Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M559.28768,556.59646H462.13013a8.09646,8.09646,0,1,1,0-16.19292h97.15755a8.09646,8.09646,0,0,1,0,16.19292Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#17BED0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.88414,
    cy: 495,
    r: 11,
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M602.70891,604.5h-140a8,8,0,1,1,0-16h140a8,8,0,0,1,0,16Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#ccc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.88414,
    cy: 543,
    r: 11,
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M602.70891,652.5h-140a8,8,0,1,1,0-16h140a8,8,0,0,1,0,16Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#ccc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M527.28768,604.59646H462.13013a8.09646,8.09646,0,1,1,0-16.19292h65.15755a8.09646,8.09646,0,0,1,0,16.19292Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#17BED0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M585.28768,652.59646H462.13013a8.09646,8.09646,0,1,1,0-16.19292H585.28768a8.09646,8.09646,0,0,1,0,16.19292Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#17BED0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M565.63963,335.17334H551.89549V294.55908a4.50508,4.50508,0,0,1,4.5-4.5h4.74414a4.50508,4.50508,0,0,1,4.5,4.5Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M573.97215,404.28613H442.59275l-.47168-74.04638a8.54263,8.54263,0,0,1,2.56885-6.14356l33.00366-32.146a8.4639,8.4639,0,0,1,5.853-2.41065l55.23779-.50488a8.55462,8.55462,0,0,1,6.58472,3.03027l.00464.00586,26.23608,32.17529a10.52647,10.52647,0,0,1,2.36231,6.63526Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M573.97215,404.28613H503.36961V337.92529a8.50742,8.50742,0,0,1,2.033-5.51611l30.67578-35.96436v.00049a8.48349,8.48349,0,0,1,6.46679-2.98437h.03223a8.48582,8.48582,0,0,1,6.47656,3.03271l22.92676,27.29395a8.51179,8.51179,0,0,1,1.99146,5.46728Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#17BED0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M544.02342,378.79785H533.80857a2.50294,2.50294,0,0,1-2.5-2.5V367.7334a2.50294,2.50294,0,0,1,2.5-2.5h10.21485a2.50295,2.50295,0,0,1,2.5,2.5v8.56445A2.50295,2.50295,0,0,1,544.02342,378.79785Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M544.02342,356.85156H533.80857a2.50294,2.50294,0,0,1-2.5-2.5v-8.36523a2.50294,2.50294,0,0,1,2.5-2.5h10.21485a2.50295,2.50295,0,0,1,2.5,2.5v8.36523A2.50295,2.50295,0,0,1,544.02342,356.85156Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M480.85227,375.46387h-10.2146a2.50295,2.50295,0,0,1-2.5-2.5v-8.564a2.50295,2.50295,0,0,1,2.5-2.5h10.2146a2.50294,2.50294,0,0,1,2.5,2.5v8.564A2.50294,2.50294,0,0,1,480.85227,375.46387Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M480.85227,353.51758h-10.2146a2.50295,2.50295,0,0,1-2.5-2.5v-8.36475a2.50295,2.50295,0,0,1,2.5-2.5h10.2146a2.50294,2.50294,0,0,1,2.5,2.5v8.36475A2.50294,2.50294,0,0,1,480.85227,353.51758Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M599.39821,405.15234H420.69484a1,1,0,0,1,0-2H599.39821a1,1,0,0,1,0,2Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.5,798.5h-817a1,1,0,0,1,0-2h817a1,1,0,0,1,0,2Z",
    transform: "translate(-190.5 -101.5)",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanding);
export default __webpack_public_path__ + "static/media/landing.5f6ea1eff2abc166b6475227b4843018.svg";
export { ForwardRef as ReactComponent };